/* content file: HeroIntro — new hero section content (no background, no logo) */

export const HeroIntro = () => {
  return (
    <div className="max-w-[640px] self-safe-end mb-8">

      {/* Title: "GA-Lotse" — Cairo Bold, underlined */}
      <h1
        className="superhero-title"
        data-aos="fade"
        data-aos-delay="200"
      >
        GA-Lotse
      </h1>

      {/* Divider A — full width */}
      <hr
        className="superhero-divider ml-1"
        data-aos="fade"
        data-aos-delay="350"
      />

      {/* Subtitle: "Digitalisierungspaket der Zukunft" — Noto Sans */}
      <h2
        className="superhero-subtitle py-0"
        data-aos="fade"
        data-aos-delay="500"
      >
        Digitalisierungspaket<br />
        der Zukunft
      </h2>

      {/* Divider B */}
      <hr
        className="superhero-divider superhero-divider"
        data-aos="fade"
        data-aos-delay="650"
      />

      {/* Tagline block — two lines, Noto Sans */}
      <div
        className="superhero-tagline pt-4 pb-8 sm:pt-8 sm:pb-12 pl-1"
        data-aos="fade"
        data-aos-delay="800"
      >
        {/* Breaks are removed on mobile to allow fluid wrapping */}
        <p className="mb-1">
          Die einheitliche Software <br className="hidden sm:block"/>
          für die Gesundheitsämter  <br className="hidden sm:block"/>
          und öffentliche Institutionen: <br className="hidden sm:block"/>
          sicher, modern und offen <br className="hidden sm:block"/>
        </p>
        <p>
          Entwickelt mit und für die <br className="hidden sm:block"/>
          Mitarbeiter:innen der Fachabteilungen
        </p>
      </div>

      {/* Button row */}
      <div
        className="flex flex-col md:flex-row gap-2 md:gap-4"
        data-aos="fade"
        data-aos-delay="1100"
        data-aos-anchor="top-bottom"
      >
        <a
          href="#hintergrund"
          className="main-button flex w-full md:w-1/2 flex-grow flex-shrink-0"
        >
          Mehr erfahren
        </a>
        <a
          href="#contact"
          className="main-button flex w-full md:w-1/2 inverse-colors flex-grow flex-shrink-0"
        >
          Kontakt aufnehmen
        </a>
      </div>

    </div>
  );
};
